import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
//import filterFactory from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';


const columns = [
    {
        dataField: 'EquipmentType',
        text: 'Equipment Type',
        sort: true,
        formatter: (cell) => {
            return (!cell ? 'Click to enter equipment type' : cell);
        },
        headerStyle: (colum, colIndex) => {
            return { width: '150px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
        },
        editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => (
            <CustomColumnEditor_EquipmentType {...editorProps} value={value} />
    )
        /*editor: {
            type: Type.SELECT,
            options: [{
                value: 'A',
                label: 'A'
            }, {
                value: 'B',
                label: 'B'
            }, {
                value: 'C',
                label: 'C'
            }, {
                value: 'D',
                label: 'D'
            }, {
                value: 'E',
                label: 'E'
            }]
        }*/
    },
    {
        dataField: 'SerialNumber',
        text: 'Serial Number',
        sort: true,
        formatter: (cell) => {
            return (!cell ? 'Click to enter serial number' : cell);
        },
        headerStyle: (colum, colIndex) => {
            return { width: '150px', textAlign: 'center', backgroundColor:'#1F419B', color:'white' };
        }
    },
    {
        dataField: 'Manufacturer',
        text: 'Manufacturer',
        sort: true,
        formatter: (cell) => {
            return (!cell ? 'Click to enter manufacturer' : cell);
        },
        headerStyle: (colum, colIndex) => {
            return { width: '150px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white'  };
        } },
    {
        dataField: 'Model',
        text: 'Model',
        sort: true,
        formatter: (cell) => {
            return (!cell ? 'Click to enter model' : cell);
        },
        headerStyle: (colum, colIndex) => {
            return { width: '135px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white'  };
        }
    }

];



const rowStyles = (row, rowIndex) => {
    let style = {};
    if (row.EquipmentType == '') {
        style.fontStyle = 'italic';
    }

    return style;
};

const defaultSorted = [{
    dataField: 'EquipmentType',
    order: 'desc'
}];

const EquipmentTable = ({ data, page, sizePerPage, onTableChange, totalSize }) => (
    <div>
        <BootstrapTable
            bootstrap4
            keyField="Id"
            wrapperClasses="table-responsive equipment-table"
            data={data}
            columns={columns} 
            //rowStyle={rowStyles}
            defaultSorted={defaultSorted}
            //filter={filterFactory()}
            noDataIndication={() => <Form.Label>Click the "Add Row" button below to add equipment to the request</Form.Label>}
            onTableChange={onTableChange}
            cellEdit={cellEditFactory({
                mode: 'click',
                autoSelectText: true,
                blurToSave: true
            })}
            striped
            hover
        />
    </div>
);

EquipmentTable.defaultProps = {
    user: '',
    sortField: 'EquipmentType',
    sortOrder: 'desc'
};

class ViewEquipmentTable extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            loadingData: false,
            currentId: 1,
            data:[]
        };

        this.handleTableChange = this.handleTableChange.bind(this)
        this.addRow = this.addRow.bind(this);
    }

    addRow(event) {
        let emptyRow = {
            Id: this.state.currentId,
            EquipmentType: '',
            SerialNumber: '',
            Manufacturer: '',
            Model: ''
        };
        this.state.data.push(emptyRow);
        this.state.currentId = this.state.currentId + 1;
        this.setState(this.state);
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        this.setState({
            loading: true,
            page,
            sortOrder,
            sortField,
            sizePerPage
        });
    }

    render() {
        const { data, sizePerPage, page } = this.state;
        return (
            <div>
                <EquipmentTable
                    data={data}
                    onTableChange={this.handleTableChange}
                />
                <Row>
                    <Col md style={{ display: 'flex' }} >
                        <Button size="sm" style={{ marginTop: '-10px', marginBottom: '10px', marginLeft: '10px', width: 'auto' }} variant="secondary" onClick={this.addRow}>Add Row</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

class CustomColumnEditor_EquipmentType extends React.Component {
    static propTypes = {
        value: PropTypes.string,
        onUpdate: PropTypes.func.isRequired
    }
    static defaultProps = {
        value: 0
    }
    getValue(event) {
        console.log(this);
        console.log(event);
        return this.value;
    }
    render() {
        const { value, onUpdate, ...rest } = this.props;
        return [
            <Form.Select 
                {...rest}
                ref={node => this.EquipmentType = node} defaultValue="Filter type" size="sm" value={value} name="EquipmentType" onChange={(event) => onUpdate(event.target.value)}>
                <option key='blankChoice' hidden value="">Filter order type</option>
                <option value="Air cooled chiller">Air cooled chiller</option>
                <option value="Air handling unit">Air handling unit (AHU)</option>
                <option value="Boiler">Boiler</option>
                <option value="Building automation system">Building automation system</option>
                <option value="Computer room air conditioning (CRAC) unit">Computer room air conditioning (CRAC) unit</option>
                <option value="Condenser">Condenser</option>
                <option value="Cooling tower">Cooling tower</option>
                <option value="Domestic water">Domestic water</option>
                <option value="Energy management system">Energy management system</option>
                <option value="Fan">Fan</option>
                <option value="Heat pump">Heat pump</option>
                <option value="Pump">Pump</option>
                <option value="Refrigerant monitor">Refrigerant monitor</option>
                <option value="Rooftop unit (RTU)">Rooftop unit (RTU)</option>
                <option value="Self-contained unit (SCU)">Self-contained unit (SCU)</option>
                <option value="Split system">Split system</option>
                <option value="Terminal unit">Terminal unit</option>
                <option value="Variable frequency drive (VFD)">Variable frequency drive (VFD)</option>
                <option value="Variable refrigerant flow (VRF)">Variable refrigerant flow (VRF)</option>
                <option value="Water cooled chiller">Water cooled chiller</option>

            </Form.Select>
        ];
    }
}

export default ViewEquipmentTable;